module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0070.jpg?v=522d4e9b";